import * as ko from 'knockout';
import { Observable } from 'knockout';

class DualListBoxItem {
    public isChecked: Observable<boolean>;
    public isSelected: Observable<boolean>;

    // this empty function is workaround to handle bubbling to distinguish clicks
    // on parent container from clicks on the checkbox
    public emptyClickBubbleHandler = (): true => {
      return true;
    }

    constructor(public id: string, public name: string, isChecked: boolean) {
      this.isChecked = ko.observable(isChecked);
      this.isSelected = ko.observable(false);
    }
}
export default DualListBoxItem;
